// extracted by mini-css-extract-plugin
export default {"wrapper":"contacts_wrapper__ndjkg","svg":"contacts_svg__i4B+1"};